module.exports = __webpack_public_path__ + "static/media/bannerInicial.0d3c5045.svg";